import script from "./MoneyKey.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyKey.vue?vue&type=script&setup=true&lang=js"

import "./MoneyKey.vue?vue&type=style&index=0&id=f156208c&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/192.255.151.37/new/tiempos-h55/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f156208c"]])

export default __exports__